import React, { useState, useEffect } from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const MaturatoAnalisiPieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const shaped = { items: [...(filterModel.items || []), { field: "status", operator: "equals", value: "accepted" }] };
        setLocalFilterModel(shaped);
        setLocalDrawable(true);
    }, [filterModel]);

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (localDrawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Maturato by Shop")}
                        dataProviderName={"statisticsviews/maturatocommissionpershop/aggregatedsumfinancial/views_opportunities_proposal/_related_shop_name/totalCommissionValue"}
                        filters={localFilterModel}
                        format="currency"
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Maturato by Buyer Agent")}
                        dataProviderName={"statisticsviews/maturatocommissionperagent/aggregatedsumfinancial/views_opportunities_proposal/_related_buyerAgent_fullname/totalCommissionValue"}
                        filters={localFilterModel}
                        format="currency"
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_buyerAgent_fullname', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Maturato by Seller Agent")}
                        dataProviderName={"statisticsviews/maturatocommissionperagent/aggregatedsumfinancial/views_opportunities_proposal/_related_sellerAgent_fullname/totalCommissionValue"}
                        filters={localFilterModel}
                        format="currency"
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_sellerAgent_fullname', addFilter)}
                    />
                </Box>
            </Box>
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Maturato by Source")}
                        dataProviderName={"statisticsviews/maturatocommissionpersource/aggregatedsumfinancial/views_opportunities_proposal/_related_source_name/totalCommissionValue"}
                        filters={localFilterModel}
                        format="currency"
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Maturato by Status")}
                        dataProviderName={"statisticsviews/maturatocommissionpersource/aggregatedsumfinancial/views_opportunities_proposal/status/totalCommissionValue"}
                        filters={localFilterModel}
                        format="currency"
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('status', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Maturato by Product")}
                        dataProviderName={"statisticsviews/maturatocommissionpersource/aggregatedsumfinancial/views_opportunities_proposal/product/totalCommissionValue"}
                        filters={localFilterModel}
                        format="currency"
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('product', addFilter)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default MaturatoAnalisiPieSet;
